<div
    class="card-rack"
    [class.card-rack--4]="type === 4"
    [class.card-rack--3]="type === 3"
    [class.card-rack--full]="type === 'fullWidth'"
    [class.card-rack-card--top-margin]="topMargin"
>
    <ng-content></ng-content>
</div>
